import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { timestamps } from "@sqlite/utils/fields";

export const DownloadType = {
  AUDIO: "audio",
  PLAYLIST_IMAGE: "playlist_image",
  ARTIST_IMAGE: "artist_image",
  ALBUM_IMAGE: "album_image",
} as const;

export const DownloadStatus = {
  PENDING: "pending",
  WAITING_FOR_AUDIO_URL: "waiting_for_audio_url",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  FAILED: "failed",
  PAUSED: "paused",
} as const;

export const downloadQueue = sqliteTable("download_queue", {
  ...timestamps,
  queueId: integer("queue_id").primaryKey({ autoIncrement: true }),
  trackId: text("track_id"),
  collectionId: text("collection_id").notNull(),
  downloadType: text("download_type", {
    enum: [
      DownloadType.AUDIO,
      DownloadType.PLAYLIST_IMAGE,
      DownloadType.ARTIST_IMAGE,
      DownloadType.ALBUM_IMAGE,
    ],
  }).notNull(),
  remoteUrl: text("remote_url").unique(),
  localPath: text("local_path").notNull(),
  status: text("status", {
    enum: [
      DownloadStatus.PENDING,
      DownloadStatus.WAITING_FOR_AUDIO_URL,
      DownloadStatus.IN_PROGRESS,
      DownloadStatus.COMPLETED,
      DownloadStatus.FAILED,
      DownloadStatus.PAUSED,
    ],
  }).notNull(),
  attempts: integer("attempts").notNull().default(0),
  resumableSnapshot: text("resumable_snapshot"),
  lastAttemptAt: text("last_attempt_at"),
  errorDetails: text("error_details"),
});

// Export Task to use as an interface in your app
export type DownloadQueue = typeof downloadQueue.$inferSelect;
